import { useBeneficiaryTransactionsData } from "@/hooks/useBeneficiaryTransactionsData";
import {
  BeneficiaryPerformanceType,
  TransactionItem,
} from "@/types/beneficiaries";
import { useTranslation } from "react-i18next";

enum TransactionsTabName {
  All = "All sources",
  Personal = "Personal",
  Employer = "Employer",
}

const AccountTransactions: React.FC<{
  beneficiaryData: BeneficiaryPerformanceType;
  beneficiaryInfo?: {
    minorFirstName?: string;
    minorLastName?: string;
  };
  activeTransactionTab: TransactionsTabName;
  setActiveTransactionTab: (tab: TransactionsTabName) => void;
}> = ({
  beneficiaryData,
  beneficiaryInfo,
  activeTransactionTab,
  setActiveTransactionTab,
}) => {
  const { t } = useTranslation();
  const transactionsData = useBeneficiaryTransactionsData(beneficiaryData, {
    firstName: beneficiaryInfo?.minorFirstName,
    lastName: beneficiaryInfo?.minorLastName,
  });

  const handleTabClick = (tabName: TransactionsTabName) => {
    setActiveTransactionTab(tabName);
  };

  const renderTransactionRow = (
    transaction: TransactionItem,
    index: number,
  ) => (
    <div key={index} className="">
      <div className="py-4 flex justify-between items-start">
        <div className="flex items-center flex-1 min-w-0">
          <div
            className={`w-3 h-3 rounded-full mr-2 flex-shrink-0 shadow-buttonPrimary ${
              transaction.type === "employee"
                ? "bg-brand-default"
                : transaction.type === "employer"
                  ? "bg-orange-500"
                  : "bg-gray-400"
            }`}
          ></div>
          <div className="min-w-0 flex-1">
            <p className="pr-2">{transaction.description}</p>
            <p className="text-xs text-black/50">{transaction.date}</p>
          </div>
        </div>
        <div className="text-right flex-shrink-0 ml-2">
          + $ {Math.trunc(Number(transaction.amount))}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="flex  border-b-[1px] border-[#E2E2E2] pb-4">
        <button
          className={`px-4 py-2 rounded-full mr-2 ${
            TransactionsTabName.All === activeTransactionTab &&
            "bg-brand-default text-white shadow-buttonPrimary"
          }`}
          onClick={() => handleTabClick(TransactionsTabName.All)}
        >
          {t("manage_account.transaction_tabs.all_sources")}
        </button>
        <button
          className={`px-4 py-2 rounded-full mr-2 ${
            TransactionsTabName.Personal === activeTransactionTab &&
            "bg-[#2FB7F2] text-white shadow-buttonPrimary"
          }`}
          onClick={() => handleTabClick(TransactionsTabName.Personal)}
        >
          {t("manage_account.transaction_tabs.personal")}
        </button>
        <button
          className={`px-4 py-2 rounded-full mr-2 ${
            TransactionsTabName.Employer === activeTransactionTab &&
            "bg-[#F69334] text-white shadow-buttonPrimary"
          }`}
          onClick={() => handleTabClick(TransactionsTabName.Employer)}
        >
          {t("manage_account.transaction_tabs.employer")}
        </button>
      </div>

      <div className="w-full">
        <div className="h-[308px] overflow-y-auto dropdown-scrollable pr-2">
          {activeTransactionTab === TransactionsTabName.All &&
            (transactionsData.allTransactions.length === 0 ? (
              <div className="text-[#00ADAC] pt-4">
                <p>
                  No transactions yet. Your transactions will appear here once
                  contributions begin.
                </p>
              </div>
            ) : (
              transactionsData.allTransactions.map((transaction, index) =>
                renderTransactionRow(transaction, index),
              )
            ))}

          {/*  {activeTransactionTab === TransactionsTabName.Personal &&
            transactionsData.personalTransactions.map((transaction, index) =>
              renderTransactionRow(transaction, index)
            )} */}

          {activeTransactionTab === TransactionsTabName.Personal &&
            (transactionsData.personalTransactions.length === 0 ? (
              <div className="text-[#00ADAC] pt-4">
                <p>
                  No personal transactions yet. Your transactions will appear
                  here once contributions begin
                </p>
              </div>
            ) : (
              transactionsData.personalTransactions.map((transaction, index) =>
                renderTransactionRow(transaction, index),
              )
            ))}

          {activeTransactionTab === TransactionsTabName.Employer &&
            (transactionsData.employerTransactions.length === 0 ? (
              <div className="text-[#00ADAC] pt-4">
                <p>
                  No employer transactions yet. Your transactions will appear
                  here once contributions begin
                </p>
              </div>
            ) : (
              transactionsData.employerTransactions.map((transaction, index) =>
                renderTransactionRow(transaction, index),
              )
            ))}
        </div>
      </div>
    </>
  );
};

export default AccountTransactions;
